import React, { useEffect, useRef, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'

interface AdditionalTextProps {
  text: string
  className: string
}

const AdditionalText: React.FC<AdditionalTextProps> = ({ text, className }) => {
  const [hasMoreThanTwoLines, setHasMoreThanTwoLines] = useState(false)
  const [isClamped, setIsClamped] = useState(true)
  const textRef = useRef<HTMLSpanElement>(null)

  const { t } = useTranslation('map')
  const checkOverflow = () => {
    const element = textRef.current
    if (element) {
      const isOverflowing = element.scrollHeight > element.clientHeight
      setHasMoreThanTwoLines(isOverflowing)
    }
  }

  useEffect(() => {
    checkOverflow()
    const resizeObserver = new ResizeObserver(() => checkOverflow())
    if (textRef.current) {
      resizeObserver.observe(textRef.current)
    }
    return () => {
      resizeObserver.disconnect()
    }
  }, [text])

  return (
    <div className={`${className}__additional`}>
      <div className={`${className}__additional__content${isClamped ? ' --init' : ''}`}>
        <span
          ref={textRef}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
      {(hasMoreThanTwoLines || !isClamped) && <div className={`${className}__additional__summary`}>
        <BackBtn
          text={t(isClamped ? 'expand' : 'collapse')}
          action={() => {
            setIsClamped(prev => !prev)
          }}
        />
      </div>}
    </div>
  )
}

export default AdditionalText